(function(TIPTOE, window, document, $) {
  'use strict';

  /** @type {Function} Custom logger */
  var log = TIPTOE.HAS_DEBUG
    ? window.console.log.bind(window, 'ADD TO CART PW GIFT CARD:')
    : function() {};

  /**
   * AddToCartPWGiftCard Class
   */
  function AddToCartPWGiftCard() {
    this.onLoad = this.onLoad.bind(this);

    window.addEventListener('load', this.onLoad);

    return this;
  }

  AddToCartPWGiftCard.prototype.onLoad = function() {
    $('#gift-card-amount').change(function() {
      var $option = $(this).find(":selected");

      $('#gift-submit-btn').attr('data-product_id', $option.data('variation'));
      $('#gift-submit-btn').attr(
        'data-pw_gift_card_from',
        $('input[name=pw_gift_card_from]').val()
      );

      if ($(this).val() != '') {
        $('#pwgc-purchase-container').show();
      } else {
        $('#pwgc-purchase-container').hide();
      }
    });

    $('#pwgc-to').change(function() {
      $('#gift-submit-btn').attr('data-pw_gift_card_to', $(this).val());
    });

    $('#pwgc-from').change(function() {
      $('#gift-submit-btn').attr('data-pw_gift_card_from', $(this).val());
    });

    $('#pwgc-message').change(function() {
      $('#gift-submit-btn').attr('data-pw_gift_card_message', $(this).val());
    });
  };

  new AddToCartPWGiftCard();
})(TIPTOE, window, document, jQuery);
